export interface Footer {
  search: Search;
  populartopics: Populartopics;
  footercolumns?: FootercolumnsEntity[] | null;
  info: Info;
  socialIcons?: SocialIconsEntity[] | null;
  feedback: Record<string, string>;
  countrylanguage: Countrylanguage;
}

/** Search placeholder text on Footer */
export interface Search {
  placeHolder: string;
}

/** Holds information of Popular topics  */
export interface Populartopics {
  heading: string;
  popularTopicsList?: PopularTopicsListEntity[] | null;
}

/** Holds information of Popular topics list like "Need Help", "COVID" */
export interface PopularTopicsListEntity {
  itemtext: string;
  itemUrl: string;
  openinnewTab: string;
}

/** Holds Footer column section text like "About Delta", "Customer Service", "Site Support", "Policies" */
export interface FootercolumnsEntity {
  tabcolheading: string;
  tabcolItems?: TabcolItemsEntity[] | null;
}

/** Holds sub column topic  links E.g., "About Us", "Login Help", "Cookies, Privacy & Security" */
export interface TabcolItemsEntity {
  tabitemtext: string;
  tabitemUrl: string;
  openinnewTab: string;
}

/** Holds footer copyright and disclaimer text */
export interface Info {
  copyright: string;
  disclaimer1: string;
  disclaimer2: string;
}

/** Holds Social Icon text and links E.g., "Twitter", "Facebook" */
export interface SocialIconsEntity {
  iconLogo: string;
  iconLink: string;
  openinnewTab: string;
  iconAlt: string;
}

/** Holds text of current country language and selector */
export interface Countrylanguage {
  id: string;
  defaultCountry: string;
  headingText: string;
  country: string;
  language: string;
  done: string;
  supportedCountry: string;
}

/** Holds Accessibility popup information */
export interface AccessibilityPopUp {
  popupTitle: string;
  popupDesc: string;
  popupQuestion: string;
  primaryLabel: string;
  secondaryLabel: string;
}

export interface FooterInformation {
  footer: Footer;
  accessibilityPopUp: AccessibilityPopUp;
}
